module.exports = __webpack_public_path__ + "static/media/peak_direct.293e2583.png";